"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var statementApi = _interopRequireWildcard(require("@/api/merchantStatement"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'EditStatementOrderDialog',
  data: function data() {
    var validateAmount = function validateAmount(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入金额'));
        return;
      }
      var amount = Number(value);
      if (isNaN(amount) || amount < 0) {
        callback(new Error('请输入正确金额'));
        return;
      }
      callback();
    };
    return {
      visible: false,
      submitLoading: false,
      orderInfo: {},
      form: {
        id: '',
        statementId: '',
        orderId: '',
        orderNo: '',
        actualSettlementFreight: '',
        actualSettlementPackingFee: ''
      },
      rules: {
        actualSettlementFreight: [{
          required: true,
          validator: validateAmount,
          trigger: 'blur'
        }],
        actualSettlementPackingFee: [{
          required: true,
          validator: validateAmount,
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    open: function open(row, statementId) {
      this.orderInfo = _objectSpread({}, row);
      this.form = {
        id: row.id,
        statementId: statementId,
        orderId: row.orderId,
        orderNo: row.orderNo,
        actualSettlementFreight: this.getDefaultAmount(row.actualSettlementFreight, row.freight),
        actualSettlementPackingFee: this.getDefaultAmount(row.actualSettlementPackingFee, row.packingFee)
      };
      this.visible = true;
    },
    handleClosed: function handleClosed() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.orderInfo = {};
      this.submitLoading = false;
    },
    getDefaultAmount: function getDefaultAmount(value, fallback) {
      if (value === '' || value === null || value === undefined) return fallback != null ? fallback : 0;
      return value;
    },
    formatAmount: function formatAmount(val) {
      return val != null && val !== '' ? Number(val).toFixed(2) : '0.00';
    },
    handleSubmit: function handleSubmit() {
      var _this = this;
      this.$refs.formRef.validate(function (valid) {
        if (!valid) return;
        _this.submitLoading = true;
        statementApi.statementOrderUpdateApi({
          id: _this.form.id,
          statementId: _this.form.statementId,
          orderId: _this.form.orderId,
          orderNo: _this.form.orderNo,
          actualSettlementFreight: Number(_this.form.actualSettlementFreight),
          actualSettlementPackingFee: Number(_this.form.actualSettlementPackingFee)
        }).then(function () {
          _this.$message.success('保存成功');
          _this.visible = false;
          _this.$emit('refresh');
        }).catch(function () {}).finally(function () {
          _this.submitLoading = false;
        });
      });
    }
  }
};